module.exports = __webpack_public_path__ + "img/full6-min.ed3c1867.png";